/**
 * Вход через Apple (пристань).
 *
 * redirectURI обязан быть одним из адресов, зарегистрированных у Apple для
 * clientId, иначе Apple отвечает invalid_grant. Бэк по умолчанию обменивает
 * код на прод-адрес, поэтому для любого другого адреса тот же URI нужно
 * продублировать в body.redirect_uri запроса login-apple.
 */

export const APPLE_CLIENT_ID = 'me.rbxpier.web'

// Адрес, на который бэк обменивает код, если redirect_uri не передан
export const APPLE_DEFAULT_REDIRECT_URI = 'https://rbxpier.me'

// Дев-фронт: сначала тестируем вход здесь. С localhost popup Apple не
// откроется — Apple проверяет домен самой страницы.
export const APPLE_DEV_REDIRECT_URI = 'https://pier-pro-test-84f213ad258d.herokuapp.com'

// Все адреса, зарегистрированные у Apple для этого clientId
export const APPLE_REGISTERED_REDIRECT_URIS = [
  APPLE_DEFAULT_REDIRECT_URI,
  'https://www.rbxpier.me',
  APPLE_DEV_REDIRECT_URI
]

/**
 * Какой redirectURI отдавать Apple для текущего origin.
 * Незарегистрированный адрес (localhost, review-приложения) всё равно не
 * пройдёт проверку Apple — отдаём дефолтный, чтобы не ловить invalid_grant.
 */
export function resolveAppleRedirectUri(origin) {
  return APPLE_REGISTERED_REDIRECT_URIS.includes(origin) ? origin : APPLE_DEFAULT_REDIRECT_URI
}

/** Нужно ли дублировать redirect_uri в теле запроса login-apple. */
export function needsExplicitRedirectUri(redirectUri) {
  return redirectUri !== APPLE_DEFAULT_REDIRECT_URI
}

// --- Страховка имени первого входа -----------------------------------------
// Имя (user) Apple присылает единственный раз — на самом первом входе юзера.
// Если наш запрос login-apple в этот момент упал, имя теряется навсегда
// (юзеру пришлось бы удалять сайт в настройках Apple ID и входить заново).
// Поэтому до успешного входа держим user в localStorage с привязкой к sub
// юзера и подкладываем его при повторной попытке.

const APPLE_PENDING_USER_KEY = 'apple_auth_pending_user'

/** sub юзера из id_token Apple (без верификации — только как ключ стеша). */
export function appleSubFromIdToken(idToken) {
  try {
    const payload = idToken.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
    return JSON.parse(atob(payload)).sub
  } catch (error) {
    return undefined
  }
}

export function savePendingAppleUser(sub, user) {
  try {
    localStorage.setItem(APPLE_PENDING_USER_KEY, JSON.stringify({ sub, user }))
  } catch (error) {
    // private mode / переполненный storage — просто без страховки
  }
}

export function loadPendingAppleUser(sub) {
  try {
    const raw = localStorage.getItem(APPLE_PENDING_USER_KEY)
    if (!raw) return undefined
    const stored = JSON.parse(raw)
    // Чужой стеш (другой Apple ID на этом браузере) не подкладываем
    return stored && stored.sub === sub ? stored.user : undefined
  } catch (error) {
    return undefined
  }
}

export function clearPendingAppleUser() {
  try {
    localStorage.removeItem(APPLE_PENDING_USER_KEY)
  } catch (error) {
    // ignore
  }
}
